import { useContext } from "react";
import {
  CXSignupDialogContext,
  CXSignupDialogContextType,
} from "./CXSignupDialogContext";

export const useCXSignupDialog = (): CXSignupDialogContextType | null => {
  return useContext(CXSignupDialogContext);
};
